var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstraintTriangle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 42,
    viewBox: "0 0 48 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5981 40.5C25.4434 42.5 22.5566 42.5 21.4019 40.5L0.61731 4.5C-0.537392 2.5 0.905983 4.64163e-06 3.21539 4.43973e-06L44.7846 8.05635e-07C47.094 6.03741e-07 48.5374 2.5 47.3827 4.5L26.5981 40.5Z",
    fill: "#FC9D2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstraintTriangle);
export default __webpack_public_path__ + "static/media/ConstraintTriangle.c919507b.svg";
export { ForwardRef as ReactComponent };